import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import AdminPanel, { adminConfigs } from "@thewebops/admin-panel";
import configureStore, { history } from "configureStore";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router/immutable";
import { adminConfigs as adminCustomConfigs } from "adminConfigs";

adminConfigs.init(adminCustomConfigs);

// A filter dropdown keeps the cursor after a choice, so a stray key starts a new search over the
// chosen value. Leave the box once something is chosen, by click or Enter.
const leaveFilterBox = () => {
  const box = document.activeElement;
  if (box?.closest(".col-wrapper .ant-select")) setTimeout(() => box.blur(), 0);
};
document.addEventListener("click", event => {
  if (event.target.closest(".ant-select-dropdown .ant-select-item-option")) leaveFilterBox();
});
document.addEventListener("keydown", event => {
  if (event.key === "Enter") leaveFilterBox();
});

export const store = configureStore();

const MOUNT_NODE = document.getElementById("root");

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <AdminPanel />
    </ConnectedRouter>
  </Provider>,
  MOUNT_NODE,
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
